import React, {useContext, useEffect, useState, useRef} from 'react'
import UserPrefContext from '../src/context/userPrefContext'
import { useNavigate } from 'react-router-dom';
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import Form from 'react-bootstrap/Form'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import InputGroup from "react-bootstrap/InputGroup";
import { BsFillEyeFill, BsFillEyeSlashFill } from "react-icons/bs";
import styles from './LoginBoxDB.module.css'
import jwt_decode from 'jwt-decode'
import AuthContext from './context/authContext';
import './LoginBoxDB.css'
import CompanyContext from './context/companyContext';


function LoginBoxDB(props) {

    const [errors, setErrors] = useState([])
    const [prevUserIsIpad, setPrevUserIsIpad] = useState(false)
    const [prevUserIsHim, setPrevUserIsHim] = useState(false)
    const [prevUserIsRegular, setPrevUserIsRegular] = useState(false)

    const [showPassword, setShowPassword] = useState(false);

    const secondsLeftSpan = useRef()
    const secondsLeft = useRef(999)
    const lInterval = useRef()


    const [doLogoutFirst, setDoLogoutFirst] = useState(false)
    const [doNotLogin, setDoNotLogin] = useState({
        allowLogin: true, 
        messages: [], 
        max_sessions_reached: false, 
        is_account_locked: false, 
        lockout_expires_at: null
    })
  
    const togglePasswordVisibility = () => {
      setShowPassword(!showPassword);
    };



    
    const userid = useRef()
    const password = useRef()
    const entity = useRef()

    const companyCtx = useContext(CompanyContext)
    const authCtx = useContext(AuthContext)
    const userPrefCtx = useContext(UserPrefContext)

    // interval for updating seconds count when lockout ends
    let lockOutInterval

    //console.log("LoginBoxDB - props", props, "companyCtx.company.auth_mode", companyCtx.company.auth_mode)
    

    let navigate = useNavigate();

    const startLockoutTimer = (unlockAt) => {
        // setup interval to trigger every second to update time left
        // by the end of 60 seconds period - logout
        lockOutInterval = setInterval( () => {
            // console.log(`logout interval - ${secondsLeft.current} left`)
            if (secondsLeft.current > 0) {
                secondsLeft.current -= 1;
                const mins = Math.trunc(secondsLeft.current/60)
                if (mins > 0) {
                    secondsLeftSpan.current.textContent = `${mins} minute(s) ${secondsLeft.current%60} second(s)`
                } else {
                    secondsLeftSpan.current.textContent = `${secondsLeft.current%60} second(s)`
                }
                
            } else {
                if (lInterval.current !== undefined) { 
                    clearInterval(lInterval.current);
                }
                setDoNotLogin({
                    allowLogin: true, 
                    messages: [], 
                    max_sessions_reached: false, 
                    is_account_locked: false, 
                    lockout_expires_at: null,
                })
            }
            
        }, 1000)

        const unlockTime = new Date(unlockAt)
        const now = new Date()
        const diff = unlockTime.getTime() - now.getTime()
        let unlockSecondsLeft = Math.floor(diff/1000)
        if (unlockSecondsLeft > 0) {
            secondsLeft.current = unlockSecondsLeft
        }

        lInterval.current = lockOutInterval
    }



    const [showDBLogin, setShowDBLogin] = useState(false)

    const handleLogin = (event) => {
        event.preventDefault();
        // console.log("LoginBoxDB: companyCtx", companyCtx.company)
        const username = userid.current.value
        
        const loginToDB = async () => {
            let url = `${process.env.REACT_APP_SERVER}/api/v1/login/access-token`
            if (companyCtx.company.auth_mode === 'AD') {
                url = `${process.env.REACT_APP_SERVER}/api/v1/login/access-token-ad/${companyCtx.company.id}`
            }
            const headers = {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Accept': 'application/json',
                'Auth': companyCtx.company.auth_mode,
            }

            setErrors([])

            const response = await fetch(url, {
                headers: headers,
                method: 'POST',
                body: new URLSearchParams({
                    username: userid.current.value,
                    password: password.current.value,
                    grant_type: 'password',
                    scope: '',
                    client_id: '',
                    client_secret: '',
                })
            })
            .then((res) => {
                // Store the status code to check after parsing JSON
                const status = res.status
                return res.json().then(data => ({ status, data }))
            })
            .then(({ status, data }) => {
                // Check for 403 errors - need to determine if it's lockout or max sessions
                if (status === 403) {
                    // Check if it's an account lockout (from detail.is_account_locked or detail.lockout_expires_at)
                    if (data.detail && (data.detail.is_account_locked || data.detail.lockout_expires_at || 
                        (data.detail.message && data.detail.message.toLowerCase().includes('locked')))) {
                        setDoNotLogin({
                            allowLogin: false, 
                            max_sessions_reached: false, 
                            is_account_locked: true,
                            messages: ['Your account is temporarily locked out due to too many unsuccessful attempts.', 'Please try to login again in '],
                            lockout_expires_at: data.detail.lockout_expires_at,
                        })
                        if (data.detail.lockout_expires_at) {
                            startLockoutTimer(data.detail.lockout_expires_at)
                        }
                        return
                    } else if (data.detail && data.detail.max_sessions_reached) {
                        // Max sessions reached
                        setDoNotLogin({
                            allowLogin: false, 
                            max_sessions_reached: true, 
                            is_account_locked: false,
                            messages: ['You have too many open sessions.', 'Please logout from other sessions first.'],
                            lockout_expires_at: null,
                        })
                        return
                    } else {
                        // Unknown 403 - treat as max sessions
                        setDoNotLogin({
                            allowLogin: false, 
                            max_sessions_reached: true, 
                            is_account_locked: false,
                            messages: ['You have too many open sessions.', 'Please logout from other sessions first.'],
                            lockout_expires_at: null,
                        })
                        return
                    }
                }
                
                // Check for successful login FIRST (access_token present)
                if (!!data.access_token) {
                    // save return in the local storage - will be used to restore sesssion on page reload

                    // fake ipad user
                    // data = {...data, is_ipad_user: true}

                    // fake him user
                    // data = {...data, is_him_user: true}

                    // store username in local storage as well
                    localStorage.setItem("db-auth-access-return", JSON.stringify({...data, username: username}))
                    // setup auth context
                    authCtx.setAuthMode(companyCtx.company.auth_mode)
                    authCtx.setIsAuthenticated(true)
                    authCtx.setToken(data.access_token)
                    authCtx.setUserInfo({
                        first_name: data.first_name,
                        last_name: data.last_name,
                        is_him_user: data.is_him_user,
                        is_ipad_user: data.is_ipad_user,
                        is_readonly: data.is_readonly,
                        is_site_admin: data.is_site_admin,
                        is_superuser: data.is_superuser,
                        is_writeuser: data.is_writeuser,
                        name: data.first_name + ' ' + data.last_name,
                        family_name: data.last_name,
                        given_name: data.first_name,
                        username: username,
                    })
                    if (!!!userPrefCtx.bearerToken || userPrefCtx.bearerToken !== data.access_token) {
                        userPrefCtx.setBearerTokenFunction(data.access_token)
                    }

                    if (!!props.onLogin) {
                        props.onLogin()
                    } else {
                        // different type of user - show page depending on the user
                        if (data.is_him_user) {
                            navigate('/him')
                        } else if (data.is_ipad_user) {
                            navigate('/ipad')
                        } else {
                            navigate('/')
                        }
                        
                    }

                    if (!!props.onHide) {
                        props.onHide()
                    } else {
                        // hide
                        setShowDBLogin(false)
                    }
                } else if (!!data.max_sessions_reached) {
                    // setDoLogoutFirst(true)
                    setDoNotLogin({allowLogin: false, 
                        max_sessions_reached: data.max_sessions_reached, 
                        is_account_locked: data.is_account_locked,
                        messages: ['You have too many open sessions.', 'Please logout from other sessions first.'],
                        lockout_expires_at: null,
                    })
                } else if (!!data.is_account_locked) {
                    // setDoLogoutFirst(true)
                    setDoNotLogin({allowLogin: false, 
                        max_sessions_reached: data.max_sessions_reached, 
                        is_account_locked: data.is_account_locked,
                        messages: ['Your account is temporary locked out due to too many unsuccessful attempts.', 'Please try to login again in '],
                        lockout_expires_at: data.lockout_expires_at,
                    })
                    startLockoutTimer(data.lockout_expires_at)

                } else if (!!data.detail) {
                    if (typeof data.detail === "string") {
                        setErrors([data.detail])
                    } else if (typeof data.detail === "object" && data.detail.message) {
                        // Handle object with message property (e.g., {"message":"Incorrect username or password","user_attempts":1})
                        setErrors([data.detail.message])
                    } else if (typeof data.detail === "object" && Array.isArray(data.detail) && data.detail.length > 0) {
                        let e = []
                        data.detail.forEach(dd => {
                            if (!!dd.loc && dd.loc.length > 1) {
                                e.push(`${dd.loc[1]} ${dd.msg}`)
                            }
                        })
                        setErrors([...e])
                    }
                } else if (!!!data.access_token) {
                    // no token returned - problem with login (whatever it is)
                    setErrors([
                        'Login failed.',
                        'Please try again'
                    ])
                }
            })
            .catch((err) => {
                console.log(err)
                console.log(err.message);
            })
        }




        const logoutOtherSession = () => {
            try {
                const url = `${process.env.REACT_APP_SERVER}/api/v1/logout/${companyCtx.company.id}?${new URLSearchParams({username: username})}`
                fetch(url, {
                    method: 'POST',
                    headers: {
                        // Authorization: `Bearer ${userPrefCtx.bearerToken}`,
                        // auth: AuthContext.authMode,
                        'Content-Type': 'application/json'
                    },
                })
                .then(response => response.json())
                .then(data => {
                    // console.log("On logout data", data)
                    // setDoLogoutFirst(false)
                    setDoNotLogin({allowLogin: true, 
                        max_sessions_reached: false, 
                        is_account_locked: false,
                        messages: []
                    })
                    setErrors([])
                })
            } catch (e) {
                console.log("Error trying to logout", e)
            }
        }

        // if (doLogoutFirst) {
        //     logoutOtherSession()
        // } else {
        //     loginToDB()
        // }
        
        if (doNotLogin.max_sessions_reached) {
            logoutOtherSession()
        } else /*if (!doNotLogin.is_account_locked)*/ {
            loginToDB()
        }


    }


    const handleCancelLogout = () => {
        // setDoLogoutFirst(false)
        setDoNotLogin({allowLogin: true, 
            max_sessions_reached: false, 
            is_account_locked: false,
            messages: []
        })
    }


    return (
        <div className={styles.fullscreen}>
            {/* <Modal size={doLogoutFirst ? "lg" : "sm"} backdrop="static" centered show={props.show || showDBLogin}  */}
            <Modal size={doNotLogin.max_sessions_reached || doNotLogin.is_account_locked ? "lg" : "sm"} backdrop="static" centered show={props.show || showDBLogin} 
                /*styles={bg}*/ 
                // backdropClassName={props.mode === 'autolock' ? styles.gray: styles.white} 
                backdropClassName={styles.white}
            >
                <Modal.Header>
                    <Modal.Title><h1>EnlightenMD</h1></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {(doNotLogin.max_sessions_reached || doNotLogin.is_account_locked) ?
                        <div className='w-100 text-center fs-5 text message'>
                            {doNotLogin.messages.map((m, mx, messages) => <p key={mx}>{m}{messages.length === mx+1 ? <span ref={secondsLeftSpan}></span>: ''}</p>)}
                            
                        </div>
                        :
                            !!props.showMessage ? 
                            <div className='w-100 text-center fs-5 text message'>{props.showMessage}</div>
                            :
                            <div className='w-100 text-center fs-4 text'>Sign In</div>
                    }

                    

                    
                    
                    <Form onSubmit={handleLogin}>
                        {/* <Row className='my-3'>      
                            <Form.Group as={Col}>
                                <Form.Label htmlFor="entity" >{companyCtx.company.auth_mode === 'AD' ? 'Domain' : 'Entity'}</Form.Label>
                                <Form.Control
                                    placeholder={companyCtx.company.auth_mode === 'AD' ? 'Domain' : 'Entity'}
                                    type='text'
                                    name="entity"
                                    autoFocus
                                    // required
                                    ref={entity}
                                />
                                </Form.Group>
                        </Row> */}
                        <Row className='my-3'>      
                            <Form.Group as={Col}>
                                <Form.Label htmlFor="userid" >{companyCtx.company.auth_mode === 'AD' ? `${companyCtx.company.company_code} Username` : 'Username'}</Form.Label>
                                <Form.Control
                                    placeholder={companyCtx.company.auth_mode === 'AD' ? `${companyCtx.company.company_code} Username` : 'Username'}
                                    type='text'
                                    name="userid"
                                    required
                                    ref={userid}
                                    disabled={doNotLogin.max_sessions_reached}
                                />
                                {/* <Form.Control.Feedback type="invalid">Email address is required</Form.Control.Feedback> */}
                                </Form.Group>
                        </Row>

                        <Row className='my-3'>      
                            <Form.Group as={Col}>
                                <Form.Label htmlFor="password" >{companyCtx.company.auth_mode === 'AD' ? `${companyCtx.company.company_code} Password` : 'Password'}</Form.Label>
                                {/* <InputGroup> */}
                                <div className="password-input-container">
                                <Form.Control
                                    placeholder={companyCtx.company.auth_mode === 'AD' ? `${companyCtx.company.company_code} Password` : 'Password'}
                                    //type='password'
                                    type={showPassword ? 'text' : 'password'}
                                    name="password"
                                    required
                                    ref={password}
                                    disabled={doNotLogin.max_sessions_reached}
                                />
                                {/* <Form.Control.Feedback type="invalid">Password is required</Form.Control.Feedback> */}
                                {/* <InputGroup.Append> */}
                                    {/* <Button variant="outline-secondary" onClick={togglePasswordVisibility}> */}
                                        {/* <BsFillEyeFill onClick={togglePasswordVisibility}>
                                            {showPassword ? 'Hide' : 'Show'}
                                        </BsFillEyeFill> */}
                                        <div className="password-toggle" onClick={togglePasswordVisibility}>
                                            {showPassword ? <BsFillEyeFill /> : <BsFillEyeSlashFill />}
                                        </div>
                                    {/* </Button> */}
                                    {/* </InputGroup.Append> */}
                                    {/* </InputGroup> */}
                                    </div>
                                </Form.Group>
                        </Row>

                        <Row>
                            <ul className={`${styles['no-bullets']} ${styles['red']}`}>
                            {errors.map((err,err_i) => <li key={err_i}>{err}</li>)}
                            </ul>
                        </Row>
                        
                        <Row>
                            {doNotLogin.max_sessions_reached ? 
                            <>
                                <div className='col'>
                                    <Button className='w-100 btn-large fs-5 text' variant="primary" /*onClick={handleLogin}*/ type="submit">
                                        Logout from other sessions
                                    </Button>
                                </div>
                                <div className='col'>
                                    <Button className='w-100 btn-large fs-5 text' variant="primary" onClick={handleCancelLogout} >
                                        Cancel
                                    </Button>
                                </div>
                            </>
                            
                            :
                            <div className='col'>
                                <Button className='w-100 btn-large fs-5 text' variant="primary" type="submit" disabled={doNotLogin.is_account_locked}>
                                    Login
                                </Button>
                            </div>
                            }
                            
                        </Row>
                    </Form>
                </Modal.Body>

            </Modal>

        </div>
    )
}

export default LoginBoxDB
